/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'project-actions.project-content.archive-error-title': 'Project could not be restored',
  'project-actions.project-content.archive-project': 'Archive project',
  'project-actions.project-content.archive-restore-error-description':
    'Project changes could not be saved. Please try again later.',
  'project-actions.project-content.copy-project': 'Copy project',
  'project-actions.project-content.copy-project.cancel': 'Cancel',
  'project-actions.project-content.copy-project.close-modal': 'Close Modal',
  'project-actions.project-content.copy-project.error': "Give your project a name so everyone knows what it's about",
  'project-actions.project-content.copy-project.failed-description':
    'There was an error cloning the project. Please try again later.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'You do not have permission to copy this project.',
  'project-actions.project-content.copy-project.failed-title': "We couldn't clone this project.",
  'project-actions.project-content.copy-project.followers': 'Followers',
  'project-actions.project-content.copy-project.include': 'Include',
  'project-actions.project-content.copy-project.links': 'Links',
  'project-actions.project-content.copy-project.project-name': 'Project name',
  'project-actions.project-content.copy-project.submit': 'Submit',
  'project-actions.project-content.copy-project.success-description': 'The project has been cloned successfully.',
  'project-actions.project-content.copy-project.success-link': 'View cloned project.',
  'project-actions.project-content.copy-project.success-title': 'Project {projectName} cloned.',
  'project-actions.project-content.copy-project.title': 'Copy project',
  'project-actions.project-content.follow': 'Follow',
  'project-actions.project-content.follow-confirmation-description':
    "We'll send you a digest containing the updates of all projects you're following every Monday morning. Why Mondays? <a>Read here.</a>.",
  'project-actions.project-content.follow-confirmation-title': "🙌🏼 You're now following this project!",
  'project-actions.project-content.follow-error-title': 'Project could not be followed',
  'project-actions.project-content.follow-unfollow-error-description':
    'Project changes could not be saved. Please try again later.',
  'project-actions.project-content.restore-project': 'Restore project',
  'project-actions.project-content.share': 'Share',
  'project-actions.project-content.unfollow': 'Unfollow',
  'project-actions.project-content.unfollow-error-title': 'Project could not be unfollowed',
};
